import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login:     (username, password) => api.post('/auth/login', { username, password }),
  verifyMFA: (username, code)     => api.post('/auth/mfa/verify', { username, code }),
  mfaSetup:  ()                   => api.get('/auth/mfa/setup'),
  mfaEnable: (username, code)     => api.post('/auth/mfa/enable', { username, code }),
  me:        ()                   => api.get('/auth/me'),
};

export const backupAPI = {
  getCustomers:   ()         => api.get('/api/customers'),
  getOverview:    (customer) => api.get('/api/overview',    { params: customer ? { customer } : {} }),
  getOperations:  (customer) => api.get('/api/operations',  { params: customer ? { customer } : {} }),
  getPerformance: (customer) => api.get('/api/performance', { params: customer ? { customer } : {} }),
  getStorage:     (customer) => api.get('/api/storage',     { params: customer ? { customer } : {} }),
  getAnalytics:   (customer) => api.get('/api/analytics',   { params: customer ? { customer } : {} }),
};

// Registro dei restore test delle VM (evidenza della bontà dei backup).
// Gli screenshot si caricano come multipart: non va impostato a mano il
// Content-Type, lo imposta il browser aggiungendo il boundary corretto.
export const restoreAPI = {
  list:   (params = {}) => api.get('/api/restore-tests', { params }),
  get:    (id)          => api.get(`/api/restore-tests/${id}`),
  create: (body)        => api.post('/api/restore-tests', body),
  update: (id, body)    => api.put(`/api/restore-tests/${id}`, body),
  remove: (id)          => api.delete(`/api/restore-tests/${id}`),
  uploadEvidence: (id, files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f, f.name));
    return api.post(`/api/restore-tests/${id}/evidence`, fd);
  },
  deleteEvidence: (evidenceId) => api.delete(`/api/restore-tests/evidence/${evidenceId}`),
};

export default api;
